import React, { ReactNode, useEffect, useState } from "react";
import { Colors } from "../../Constants/colors";
import { useMobile } from "../../hooks/deviceHooks/useDevice.hooks";
import { BtnSize, BtnType, Button } from "../Button";
import CrossIcon from "./../../images/Cross.svg";
import { createPortal } from "react-dom";

export enum ModalSize {
  xs = "xs",
  sm = "sm",
  md = "md",
  lg = "lg",
}
interface SubmissionButton {
  text?: string;
  onClick: () => unknown;
  isSubmitLoading?: boolean;
  buttonType?: BtnType;
}
interface Props {
  show: boolean;
  onClose: () => unknown;
  modalHeader?: string | null;
  children: ReactNode;
  footerComponent?: ReactNode;
  modalSize?: ModalSize;
  submissionButton: SubmissionButton;
  requiresCloseIcon?: boolean;
}
export const Modal = ({
  modalHeader = null,
  show,
  children,
  onClose,
  modalSize = ModalSize.sm,
  submissionButton = {
    isSubmitLoading: false,
    text: "Save",
    onClick: () => {},
    buttonType: BtnType.secondary,
  },
  requiresCloseIcon = true,
}: Props) => {
  const portalRoot = document.getElementById("app-root");

  const isMobile = useMobile();

  const [marginTop, setMarginTop] = useState(window.scrollY + "px");
  const [height, setHeight] = useState(window.innerHeight + "px");

  useEffect(() => {
    const handleResize = () => getWindowHeight();
    const handleScroll = () => handleMarginTop();

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [show]);

  const getWindowHeight = () => {
    setHeight(window.innerHeight + "px");
  };

  const handleMarginTop = () => {
    setMarginTop(window.scrollY + "px");
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Close the modal only if the click is outside the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!portalRoot) {
    return null; // or handle the absence of portalRoot as needed
  }

  return show ? (
    createPortal(
      <div
        className="w-full flex flex-col justify-center items-center fixed top-0 left-0"
        style={{
          background: "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.4))",
          zIndex: 9999,
          height,
          marginTop,
          marginLeft: !isMobile ? "10%" : undefined,
        }}
        onClick={handleOverlayClick}
      >
        <div
          className="rounded-none md:rounded-md lg:rounded-md no-scrollbar flex flex-col"
          style={{
            // marginBottom: "50px",
            backgroundColor: Colors.White,
            height: isMobile
              ? "100%"
              : modalSize === ModalSize.sm
              ? "70%"
              : modalSize === ModalSize.xs
              ? "350px"
              : "90%",

            width: isMobile
              ? "100%"
              : modalSize === ModalSize.lg
              ? "800px"
              : modalSize === ModalSize.sm
              ? "400px"
              : modalSize === ModalSize.xs
              ? "350px"
              : "600px",

            overflow: "scroll",
            position: "relative",
          }}
        >
          {requiresCloseIcon ? (
            <div
              className="absolute top-2 right-2"
              style={{
                color: Colors.Black,
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
              onClick={onClose}
            >
              <img src={CrossIcon} alt="cross" />
            </div>
          ) : (
            <div />
          )}
          {modalHeader ? (
            <div className="Header text-3xl pr-8 pl-8 pt-8">{modalHeader}</div>
          ) : (
            <></>
          )}

          <div className="p-8 flex-1">{children}</div>

          {/*    THIS IS FOOTER FOR MODAL */}
          <div
            className="h-20 w-full p-8"
            style={{
              backgroundColor: Colors.White,
              position: "sticky",
              bottom: 0,
              borderTop: `1px solid ${Colors.DarkOffWhite}`,
            }}
          >
            <div
              className="flex items-center h-full"
              style={{
                justifyContent:
                  modalSize === ModalSize.xs ? "center" : "flex-end",
              }}
            >
              <div className="w-80 flex gap-6">
                <Button
                  onClick={() => {
                    onClose();
                  }}
                  text="Cancel"
                  btnSize={BtnSize.sm}
                  btnType={BtnType.basic}
                />

                <Button
                  onClick={submissionButton.onClick}
                  text={submissionButton.text || "Save"}
                  btnSize={BtnSize.sm}
                  btnType={submissionButton.buttonType}
                  loading={submissionButton.isSubmitLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>,
      portalRoot
    )
  ) : (
    <></>
  );
};
